import { ISelectOption } from '@apps-common/types/form'

export enum OrderStatus {
  cancelled = 'cancelled',
  pending = 'pending',
  complete = 'complete'
}

export const ORDER_STATUS_PENDING = OrderStatus.pending
export const ORDER_STATUS_COMPLETE = OrderStatus.complete
export const ORDER_STATUS_CANCELLED = OrderStatus.cancelled

export const ORDER_STATUS_VALUES: ISelectOption[] = [
  { label: 'Pending', value: ORDER_STATUS_PENDING },
  { label: 'Complete', value: ORDER_STATUS_COMPLETE },
  { label: 'Cancelled', value: ORDER_STATUS_CANCELLED }
]

export const enum CreateOrderSteps {
  details = 'details',
  orderline = 'orderline',
  summary = 'summary'
}

export enum OrderUnitType {
  Inactive = 'inactive',
  Active = 'active',
  Create = 'create'
}
